export default __webpack_public_path__ + "static/assets/med_capsule_V_tran_01_b.6d8744d6.png";